"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "content-wrapper" };
const _hoisted_2 = { class: "referral-header" };
const _hoisted_3 = { class: "referral-text" };
const vue_3 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const Modal_vue_1 = __importDefault(require("./Modal.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ReferralAdModal',
    props: {
        branchId: {
            type: Number,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
    },
    setup(__props, { expose: __expose }) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const isVisible = (0, vue_3.ref)(false);
        const props = __props;
        function closeModal() {
            isVisible.value = false;
        }
        function openModal() {
            isVisible.value = true;
        }
        function openReferralPage() {
            window.location.href = `/dashboard/${props.userId}/referral?c=${props.branchId}`;
        }
        __expose({
            openModal,
            closeModal,
        });
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    onCloseModal: closeModal,
                    "has-title-divider": true,
                    "has-footer-divider": true
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)('dash.nav.referral')), 1 /* TEXT */)
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('referral.header')), 1 /* TEXT */),
                            _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("img", {
                                class: "referral-image",
                                src: "https://storage.googleapis.com/opluswork.com/dashboard/registration-banner.jpg",
                                alt: ""
                            }, null, -1 /* CACHED */)),
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)('referral.subtitle_line1')), 1 /* TEXT */),
                                _cache[0] || (_cache[0] = (0, vue_2.createElementVNode)("br", null, null, -1 /* CACHED */)),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('referral.subtitle_line2')), 1 /* TEXT */)
                            ])
                        ])
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("button", {
                            class: "oplus-modal-btn",
                            type: "button",
                            onClick: openReferralPage
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('referral.learn_more')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
